import { useDevice } from '@/hooks/useDevice'
import { useDeepSearchList } from '../components/AiDeepSearch'

export const useListProcess = () => {
  const list = shallowRef([])
  const { list: deepSearchList } = useDeepSearchList()
  const { deviceType } = useDevice()

  let inserted = []
  const queue = []

  watch(deepSearchList, (deepSearchList) => {
    if (deepSearchList.length === 0) return
    deepSearchList.forEach(item => {
      queue.push({
        type: 'ai-search-spot',
        ...item
      })
    })
    const processed = handleRawList(list.value, true)
    list.value = processed
  }, {
    immediate: true
  })

  /**
   * 列表清空则意味着已插入的数据也都没有了，所以 inserted 也需要清空
   */
  watch(list, (list) => {
    if (list.length === 0) {
      inserted = []
    }
  })

  /**
   * 根据用户当前视口位置，计算出合适的插入位置
   * @returns {number} index
   */
  const calcInsertIndexWithOffset = () => {
    const container = document.querySelector('.product-list')
    const item = document.querySelector('.product-item')

    if (container == null || item == null) return
    /**
     * 获取商品卡片高度 和 一行渲染的商品数量
     */
    const { offsetTop, clientHeight } = item

    const columns = window.getComputedStyle(container).gridTemplateColumns.split(' ').length

    /**
     * 高度 = 商品卡片高度 + 卡片间间距
     */
    const height = clientHeight + (deviceType.value === 'MOBILE' ? 16 : 20)
    const { scrollTop } = document.documentElement
    /**
     * 计算插入位置：视口高度 + 滚动距离 - 容器距 html 顶部高度
     */
    const index = Math.ceil((window.innerHeight + scrollTop - offsetTop) / height) * columns
    return index
  }

  /**
   * 根据之前的列表数据，计算出在新数据中合适的插入位置
   * @returns {number} index
   */
  const calcInsertIndexWithList = () => {
    /**
     * 计算已插入的 Spot 所占长度
     */
    const insertedStep = inserted.reduce((pre, cur) => {
      if (cur.type === 'ai-search-spot') return pre + 4
      return pre + 1
    }, 0)
    /**
     * 计算出当前处于第几列
     */
    const currentRow = (list.value.length - inserted.length + insertedStep) % 6

    /**
     * 计算出初始索引点
     */
    const index = 6 - currentRow

    return index
  }

  /**
   * 处理原 Product 列表数据，计算合适的插入位置
   * isFollowOffset - 是否根据当前视口位置，计算出合适的插入位置
   * * true - 则调用 calcInsertIndexWithOffset 计算插入位置
   * * false - 则调用 calcInsertIndexWithList 计算插入位置
   */
  const handleRawList = (raw, isFollowOffset = false) => {
    if (queue.length === 0) return raw
    const startIndex = isFollowOffset ? calcInsertIndexWithOffset() : calcInsertIndexWithList()

    const list = [...raw]
    /**
     * 移动端插入准则：
     * 1. 不插入到数组第一个（防止之前处理时将 queue 数据插入到最后一个）
     * 2. queue 数据每个都需以 3 的步长区分
     * 3. queue 数据在插入后需要从 queue 中移除，并添加到 inserted 数组中
     */
    if (deviceType.value === 'MOBILE') {
      let index = startIndex + 1

      while (queue.length && index < list.length) {
        const item = queue.shift()
        list.splice(index, 0, item)
        inserted.push(item)
        index += 3
      }
      return list
    }
    /**
     * PC端插入准则：
     * 1. 类型为 'ai-search-spot' 占 4 列
     * 2. 'ai-search-spot' 间步长为 4
     * 3. 需计算出最新一行的起始点给到 'ai-search-spot' 使用
     */
    let index = startIndex
    console.log(index)
    /**
     * 用于配置动态步长设置
     */
    let odd = false

    while (queue.length && index < list.length) {
      const item = queue.shift()
      list.splice(index, 0, item)
      inserted.push(item)
      if (item.type === 'ai-search-spot') index += odd ? 7 : 11
      else index += 3
      odd = !odd
    }
    return list
  }

  return {
    list,
    handleRawList
  }
}
